import React, {createContext, FC, useEffect, useMemo, useRef, useState} from 'react';
import {useSession} from 'next-auth/react';
import {initializeApollo} from '@utils/apollo-client';
import {ApolloProvider} from '@apollo/client';
import {useOpenReplay} from "@utils/openReplay";

export type AuthorizedApolloClientProps = {
    initialCache: any;
};

export const AccessTokenContext = createContext('');

export const AuthorizedApolloClient: FC<AuthorizedApolloClientProps> = ({children, initialCache}) => {
    const {data} = useSession();
    const sessionRef = useRef(data);
    const tracker = useOpenReplay();
    const [accessToken, setAccessToken] = useState<string>('');
    const apolloClient = useMemo(() => {
        return initializeApollo(initialCache, sessionRef, tracker.recordGraphQLRef);
    }, [initialCache, tracker]);

    useEffect(() => {
        sessionRef.current = data;
        setAccessToken(data?.accessToken ?? '');
    }, [data]);

    return (
        <ApolloProvider client={apolloClient}>
            <AccessTokenContext.Provider value={accessToken}>
                {children}
            </AccessTokenContext.Provider>
        </ApolloProvider>
    );
};
